import { UIText2 } from '@cian/ui-kit';
import { IconSocialLikeOn16, IconSocialDislikeOn16 } from '@cian/ui-kit-design-tokens/icons';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './ClientReaction.css';
import { ELikeDislikeReaction } from '../../repositories/favorites/entities/favorite_entity_for_desktop/ClientReactionsToOfferSchema';

interface IClientReactionProps {
  likeDislikeReaction: ELikeDislikeReaction;
  isSearcherOrSub: boolean;
}

export const ClientReaction = ({ likeDislikeReaction, isSearcherOrSub }: IClientReactionProps) => {
  return likeDislikeReaction === 'like' ? (
    <div {...mergeStyles(styles['reaction'], styles['like'])} data-testid="like_block">
      <IconSocialLikeOn16 color="current_color" />
      <UIText2 color="current_color">{isSearcherOrSub ? 'Нравится' : 'Нравится клиенту'}</UIText2>
    </div>
  ) : (
    <div {...mergeStyles(styles['reaction'], styles['dislike'])}>
      <IconSocialDislikeOn16 color="current_color" />
      <UIText2 color="current_color">{isSearcherOrSub ? 'Не нравится' : 'Не нравится клиенту'}</UIText2>
    </div>
  );
};
